var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRedArrow = function SvgRedArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.293.707a1,1,0,0,1,1.414,0l4.586,4.586A1,1,0,0,1,11.586,7H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(14 23) rotate(180)",
    fill: "#df2222"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedArrow, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSI3IiB2aWV3Qm94PSIwIDAgMTQgNyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMTYpIj4KICAgIDxwYXRoIGQ9Ik02LjI5My43MDdhMSwxLDAsMCwxLDEuNDE0LDBsNC41ODYsNC41ODZBMSwxLDAsMCwxLDExLjU4Niw3SDIuNDE0YTEsMSwwLDAsMS0uNzA3LTEuNzA3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQgMjMpIHJvdGF0ZSgxODApIiBmaWxsPSIjZGYyMjIyIi8+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };